<template>
  <tr-dialog
    ref="modal"
    name="tfa-activation-dialog"
    :on-save="submitForm"
    :on-close="onHidden"
    save-button-label="Ativar"
    title="Ativar autenticação em 2 fatores"
  >
    <tr-form
      ref="form"
      :on-valid-submit="activate"
    >
      <tfa-activation-container
        ref="tfaActivation"
        :on-save="close"
      />
    </tr-form>
  </tr-dialog>
</template>

<script>
import TfaActivationContainer from './TfaActivationContainer';

export default {
  name: 'tfa-activation-dialog',
  components: {
    TfaActivationContainer
  },
  props: {
    onHidden: {
      required: true,
      type: Function
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.submitForm();
    },
    activate() {
      this.$refs.tfaActivation.onConfirm();
    },
    open() {
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
    }
  }
};
</script>
